/** @jsxImportSource solid-js */
import { createSignal, createUniqueId, For, type JSX } from "solid-js";

/**
 * Creates a simple checkbox that reports whether or not it is checked.
 */
export function createCheckboxInput(label: JSX.Element, initial = false) {
  const id = createUniqueId();
  const [checked, setChecked] = createSignal(initial);
  const [disabled, setDisabled] = createSignal(false);

  return {
    // TODO: style this a little bit more
    component: (
      <label for={id} class="block mt-2">
        <input
          type="checkbox"
          id={id}
          class="inline h-4 w-4 rounded mr-2 mt-1 text-brand-900 border-brand-300"
          checked={checked()}
          onInput={(e) => {
            setChecked(e.currentTarget.checked);
          }}
          disabled={disabled()}
        />
        {label}
      </label>
    ),
    value: checked,
    set: setChecked,
    disable: (n: boolean) => {
      setDisabled(n);
    },
  };
}

interface checkboxOptions {
  label: string;
  selected: boolean;
}

/**
 * Creates a group of checkboxes that reports the selected values.
 */
export function createCheckboxGroup(options: checkboxOptions[], label = "") {
  const theseOptions = options.map((l) =>
    createCheckboxInput(l.label, l.selected),
  );

  return {
    component: (
      <>
        <p class="font-bold mt-4">{label}</p>
        <For each={theseOptions}>{(item) => item.component}</For>
      </>
    ),
    value: () =>
      theseOptions
        .map((e, i) => {
          if (e.value()) {
            return options[i].label;
          }

          return null;
        })
        .filter((e) => e !== null),
    disable: (n: boolean) => {
      theseOptions.map((e) => {
        e.disable(n);
      });
    },
  };
}
